// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__H07Mh","topBottomGutter":"Layout_topBottomGutter__1EdDp"};